import AnalyticService from '@/api/AnalyticService'

// automatically namespaced based on the path the module is registered
const namespaced = true

// initial state
const state = {
  businessType: [],
  businessCategory: [],
  activeUsers: [],
  shopDailySale: [],
  shopAvgProductPrice: [],
  trendApp: [],
  trendAppModule: [],
}

// getters
const getters = {
  getState: state => (key) => {
    return state[key]
  },
}

// mutations
const mutations = {
  setState (state, data) {
    for (let key in data) {
      state[key] = data[key]
    }
  },
}

// actions
const actions = {
  async getBusinessType ({ commit }) {
    var result = null

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await AnalyticService.getBusinessType()

      result = response.data

      if (result.success) {
        commit('setState', {
          'businessType': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async getBusinessCategory ({ commit }) {
    var result = null

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await AnalyticService.getBusinessCategory()

      result = response.data

      if (result.success) {
        commit('setState', {
          'businessCategory': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async getActiveUsers ({ commit }) {
    var result = null

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await AnalyticService.getActiveUsers()

      result = response.data

      if (result.success) {
        commit('setState', {
          'activeUsers': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async getShopDailySale ({ commit }, shopId) {
    var result = null

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await AnalyticService.getShopDailySale(shopId)

      result = response.data

      if (result.success) {
        commit('setState', {
          'shopDailySale': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async getShopAvgProductPrice ({ commit }) {
    var result = null

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await AnalyticService.getShopAvgProductPrice()

      result = response.data

      if (result.success) {
        commit('setState', {
          'shopAvgProductPrice': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async getTrendApp ({ commit }) {
    var result = null

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await AnalyticService.getTrendApp()

      result = response.data

      if (result.success) {
        commit('setState', {
          'trendApp': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async getTrendAppModule ({ commit }, appId) {
    var result = null

    console.log('appId', appId)

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await AnalyticService.getTrendAppModule(appId)

      result = response.data

      if (result.success) {
        commit('setState', {
          'trendAppModule': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Analytic.js